import ProjectSession from "../../../model2/project/project-session"
import {SelectParent_SectionType} from "../@const"
import {selectParent_filter, selectParent_searchAndFilter} from "./filter"
import {SpaceProto} from "../../../model2/space/space-proto"
import ProjectSessionCollection from "../../../model2/project/collection"
import {EntityType} from "../../../gd/const/item"

// const debug = 'selectParent_getProjects'
const debug = false

export const selectParent_getProjects = (currentSection?:SelectParent_SectionType | SpaceProto, params?: {
    availableProjects?  : ProjectSessionCollection
    searchString?       : string
    parentsFor?         : EntityType
}) => {

    let projects: ProjectSession[] = []

    if (currentSection) {
        switch (currentSection) {
            case SelectParent_SectionType.STARRED:
                projects = gd.session.starredItems.starredProjects
                selectParent_filter(projects, params?.parentsFor, params?.availableProjects)
                break

            case SelectParent_SectionType.PINNED:
                const projectsCollection = params?.availableProjects || gd.session.projects
                projects = gd.session.pins.getSessionProjects(projectsCollection)
                selectParent_filter(projects, params?.parentsFor, params?.availableProjects)
                break

            case SelectParent_SectionType.SEARCH:
                debug && console.log(debug, 'process [', params?.searchString, ']', params?.parentsFor, params?.availableProjects)

                if (params?.parentsFor) {
                    projects = selectParent_searchAndFilter(params?.searchString!, params?.parentsFor, params?.availableProjects)
                } else {
                    console.warn('selectParent_getProjects: "parentsFor" is required for search')
                }
                break

            default:
                projects = (currentSection as SpaceProto).rootProjects
                selectParent_filter(projects, params?.parentsFor, params?.availableProjects)
                break
        }
    }

    debug && console.log(debug, 'process projects', projects)

    return projects
}